import React, { lazy } from 'react';
import { ArrowDownIcon } from 'lucide-react';
const ANA_IMAGE = 'https://cdn.magicpatterns.com/uploads/326VeAMMbzfc2xhaDM3TT9/hf_20260301_203344_3261ae83-06cc-4ce6-b5fa-905be4ea50e4.jpg';
export function Benefits() {
  return <section className="relative py-8 px-0 bg-[#FFF8F0]" data-id="element-15">
      {/* Card container */}
      <div className="mx-3 md:mx-auto max-w-2xl rounded-[20px] p-6 md:p-10 bg-[#F5EDD8]" style={{
      boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
    }} data-id="element-16">
        {/* 16:9 photo */}
        <div className="flex justify-center mb-4" data-id="element-17">
          <div className="w-full max-w-md aspect-video rounded-xl overflow-hidden border-[3px] border-cta-green flex-shrink-0" style={{
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }} data-id="element-18">
            <img src={ANA_IMAGE} alt="Ana — creadora de Flanes Sin Horno" className="w-full h-full object-cover" loading="lazy" data-id="element-19" />
          </div>
        </div>

        {/* Over-title */}
        <p className="text-cta-green font-bold tracking-widest uppercase text-center mb-2 text-[28px]" data-id="element-20">
          ¿QUIÉN SOY?
        </p>

        {/* Main title */}
        <h2 className="text-base md:text-xl font-heading font-semibold text-center text-brown-dark mb-4 leading-snug" data-id="element-21">
          Soy Ana, madre y desde hace poco abuela, con 62 años. Y hace tres años
          también me preguntaba cómo iba a llegar a fin de mes.
        </h2>

        {/* Decorative separator */}
        <div className="flex justify-center mb-5" data-id="element-22">
          <div className="w-[60px] h-px bg-cta-green/40" data-id="element-23"></div>
        </div>

        {/* Body copy */}
        <div className="space-y-4 text-sm md:text-base text-brown-dark font-medium" style={{
        lineHeight: '1.7'
      }} data-id="element-24">
          <p data-id="element-25">Miraba los precios del supermercado y hacía cuentas.</p>

          <p data-id="element-26">
            El alquiler subiendo. La luz por las nubes. El sueldo exactamente
            igual que hace cinco años.
          </p>

          <p data-id="element-27">
            Un día, harta de que el dinero nunca alcanzara, decidí probar algo
            que me parecía una locura: hacer flanes sin horno y venderlos al
            grupos de vecinos.
          </p>

          {/* Pull Quote 1 */}

          {/* Pull Quote 2 */}
          <div className="bg-white rounded-lg border-l-4 border-cta-green pl-3 pr-3 py-2 my-4" data-id="element-28">
            <p className="text-cta-green italic md:text-lg text-[16px] font-[600]" data-id="element-29">
              La primera semana vendí 12 flanes, Al mes ya tenia clientas
              haciéndome pedidos de 40, 50 miniflanes para cumpleaños
            </p>
          </div>

          {/* Result card — green dark */}
          <div className="bg-cta-green rounded-xl p-5 my-5" data-id="element-30">
            <p className="text-center font-bold text-white text-base md:text-xl leading-relaxed" data-id="element-31">
              Hoy me saco entre{' '}
              <strong className="text-[110%]" data-id="element-32">$400 y $600</strong> extra al mes.
              Sin jefe. Sin horarios. Desde mi cocina. Y sin encender el horno
              ni una sola vez.
            </p>
          </div>

          <p data-id="element-33">
            Lo que descubrí es que los flanes sin horno tienen tres ventajas que
            ningún otro postre tiene:
          </p>

          {/* Flan bullets */}
          <div className="divide-y divide-gray-300/50" data-id="element-34">
            <div className="flex items-start gap-2.5 py-2" data-id="element-35">
              <span className="text-lg md:text-xl flex-shrink-0" data-id="element-36">🍮</span>
              <p data-id="element-37">
                Se hacen en <strong className="text-[110%]" data-id="element-38">15 minutos</strong>{' '}
                — sin esperar, sin temporizadores, sin que se hundan.
              </p>
            </div>
            <div className="flex items-start gap-2.5 py-2" data-id="element-39">
              <span className="text-lg md:text-xl flex-shrink-0" data-id="element-40">🍮</span>
              <p data-id="element-41">
                Los ingredientes cuestan poco — y los tienes casi todos en casa.
              </p>
            </div>
            <div className="flex items-start gap-2.5 py-2" data-id="element-42">
              <span className="text-lg md:text-xl flex-shrink-0" data-id="element-43">🍮</span>
              <p data-id="element-44">
                Se venden solos — porque son diferentes a lo que compra todo el
                mundo.
              </p>
            </div>
          </div>

          <p className="text-brown-dark/70" data-id="element-45">
            No soy cocinera profesional. No tengo título. No tenía experiencia
            vendiendo.
          </p>

          {/* Closing bold paragraph */}
          <p className="text-center font-bold text-cta-green text-base md:text-lg pt-4" data-id="element-46">
            Solo tenía un método que funciona. Y ahora quiero dártelo a ti.
          </p>
        </div>
      </div>

      {/* Arrow below card */}
      <div className="flex justify-center mt-5" data-id="element-47">
        <ArrowDownIcon className="w-6 h-6 text-cta-green/40" data-id="element-48" />
      </div>
    </section>;
}